<template>
  <b-modal
    v-model="this.$store.state.modal"
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
    size="sm"
    static
  >
    <h6 class="text-center">
      {{processText}}
    </h6>
    <p class="text-center">
      <b-spinner type="grow" style="color:#56a7da"/>
    </p>
  </b-modal>
</template>
<script>
export default {
  created: function () {
    if (this.$attrs.autoShow === 'false') {
      this.$store.commit('showModal', false)
    } else {
      this.$store.commit('showModal', true)
    }
  },
  computed: {
    processText: function () {
      let tyText = this.$store.state.modalText
      if (this.$store.state.thankYouModalText === 'defaultTemplate') {
        let thankYouModalTemplate = `Thank you for reaching out to  {{options.dba}}. We have received your request for {{options.action}}. We will process your request in accordance with applicable law. Further inquiries can be directed to consumerinquiries@dmsgroup.com. We appreciate your patience while we process your request.`
        return thankYouModalTemplate
      } else {
        return tyText
      }
    }
  }
}
</script>
